"use client";

import { ComponentProps, forwardRef } from "react";

import cn from "classnames";
import { observer } from "mobx-react";
import Link from "next/link";

import styles from "./Button.module.scss";

interface ButtonProps {
  containerClassName?: string;
  children?: React.ReactNode;
  text?: string;
  variant?: ButtonType;
  link?: string;
  type?: ComponentProps<"button">["type"];
  onClick?: () => void;
}

type ButtonType = "main" | "secondary" | "soft" | "soft-secondary" | "text";

export const Button = observer(
  forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
    const {
      containerClassName,
      text,
      children,
      variant = "main",
      link,
      type,
      onClick,
    } = props;

    const buttonClasses = cn(styles.button, styles[variant]);

    const containerClasses = cn(
      styles.container,
      containerClassName,
      buttonClasses
    );

    if (link) {
      return (
        <Link className={containerClasses} href={link}>
          {text ?? children}
        </Link>
      );
    }

    return (
      <button
        ref={ref}
        type={type}
        className={containerClasses}
        onClick={onClick}
      >
        {text ?? children}
      </button>
    );
  })
);
